import moment from 'moment'

export function format (value, format = 'YYYY-MM-DD') {
  if (!value) {
    return '-'
  }

  try {
    return moment(value).format(format)
  } catch (err) {
    console.error('moment format filter error: ', err)
    return '-'
  }
}

export function getDaySpan (data = {}, startKey, endKey) {
  if (!data[startKey] || !data[endKey]) {
    return
  }
  // NOTE: 获取日期精确到天
  let start = moment(data[startKey]).format('YYYY-MM-DD')
  let end = moment(data[endKey]).format('YYYY-MM-DD')
  // NOTE: 根据日期差计算跨天天数
  const daySapn = Math.floor((moment(end).valueOf() - moment(start).valueOf()) / (24 * 3600 * 1000))
  return daySapn ? `+${daySapn}天` : ''
}
